export class TeamSettingEntity {

    public get name(): string {
        if (!this.suffix) {
            return this.association;
        }
        return this.association + ' ' + this.suffix;
    }

    public static fromDto(dto: any): TeamSettingEntity {
        if (!dto) {
            return new TeamSettingEntity();
        }
        const entity = new TeamSettingEntity();

        entity.id = dto.id;
        entity.groupId = dto.groupId ?? null;
        entity.associationId = dto.associationId ?? null;
        entity.association = dto.association;
        entity.suffix = dto.suffix;
        entity.gameCount = dto.gameCount ?? null;
        entity.concurrency = dto.concurrency;
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): TeamSettingEntity[] {
        const entities: TeamSettingEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = TeamSettingEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public static toDtoArray(entityArray: TeamSettingEntity[]): any[] {
        const dtos: any[] = [];
        for (const entity of entityArray) {
            dtos.push(entity.toDto());
        }
        return dtos;
    }

    public id: string = null;
    public groupId: string | null = null;
    // Server-assigned; null until the team has been saved at least once.
    public associationId: string | null = null;
    public association: string = '';
    public suffix: string = '';
    // Null means "use the schedule's SerieSetting.GameCount"; a value here overrides it for this team.
    public gameCount: number | null = null;
    public concurrency: string;

    constructor(association?: string, suffix?: string, gameCount?: number | null) {

        this.association = association;

        if (suffix) {
            this.suffix = suffix;
        }
        if (gameCount != null) {
            this.gameCount = gameCount;
        }
    }

    public getEffectiveGameCount(serieGameCount: number): number {
        return this.gameCount ?? serieGameCount;
    }

    public toDto(): any {
        return {
            id: this.id,
            groupId: this.groupId,
            association: this.association,
            suffix: this.suffix,
            gameCount: this.gameCount,
            concurrency: this.concurrency
        };
    }
}
